module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "操作说明",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v(" 多规格说明：默认列表中只显示多规格的默认值，如果想要显示全部规格列表，请选择【多规格分开展示】后搜索，该状态下不可编辑商品")])])], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品名称",
      "size": "small"
    },
    model: {
      value: (_vm.params.keywords),
      callback: function($$v) {
        _vm.$set(_vm.params, "keywords", $$v)
      },
      expression: "params.keywords"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "商品编号",
      "size": "small"
    },
    model: {
      value: (_vm.params.item_bn),
      callback: function($$v) {
        _vm.$set(_vm.params, "item_bn", $$v)
      },
      expression: "params.item_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.goodsSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "placeholder": "运费模板",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChangeTemplates
    },
    model: {
      value: (_vm.templates_id),
      callback: function($$v) {
        _vm.templates_id = $$v
      },
      expression: "templates_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "placeholder": "商品产地",
      "options": _vm.regions,
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_regions_value),
      callback: function($$v) {
        _vm.select_regions_value = $$v
      },
      expression: "select_regions_value"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择状态"
    },
    on: {
      "change": _vm.goodsSearch
    },
    model: {
      value: (_vm.params.approve_status),
      callback: function($$v) {
        _vm.$set(_vm.params, "approve_status", $$v)
      },
      expression: "params.approve_status"
    }
  }, [_vm._l((_vm.statusOption), function(item) {
    return (_vm.login_type != 'distributor') ? _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.shopStatusOption), function(item) {
    return (_vm.login_type == 'distributor') ? _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.title,
        "size": "mini",
        "value": item.value
      }
    }) : _vm._e()
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "placeholder": "选择品牌",
      "filterable": "",
      "options": _vm.goodsBranchList,
      "props": {
        value: 'attribute_id',
        label: 'attribute_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_branch_value),
      callback: function($$v) {
        _vm.select_branch_value = $$v
      },
      expression: "select_branch_value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择分类",
      "options": _vm.categoryList,
      "props": {
        value: 'category_id',
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_category_value),
      callback: function($$v) {
        _vm.select_category_value = $$v
      },
      expression: "select_category_value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "small",
      "filterable": "",
      "placeholder": "选择标签",
      "options": _vm.tag.list,
      "props": {
        value: 'tag_id',
        label: 'tag_name'
      },
      "clearable": ""
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.select_tags_value),
      callback: function($$v) {
        _vm.select_tags_value = $$v
      },
      expression: "select_tags_value"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品类型"
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.params.special_type),
      callback: function($$v) {
        _vm.$set(_vm.params, "special_type", $$v)
      },
      expression: "params.special_type"
    }
  }, _vm._l((_vm.special_type_list), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "商品类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "多规格展示"
    },
    on: {
      "change": _vm.searchAction
    },
    model: {
      value: (_vm.params.is_sku),
      callback: function($$v) {
        _vm.$set(_vm.params, "is_sku", $$v)
      },
      expression: "params.is_sku"
    }
  }, _vm._l((_vm.sku_list), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "商品类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "md": 10,
      "lg": 12
    }
  }, [_c('el-input', {
    attrs: {
      "rows": 1,
      "placeholder": "多商品货号，多个货号使用回车换行",
      "type": "textarea",
      "clearable": "",
      "size": "mini"
    },
    model: {
      value: (_vm.search_item_bns),
      callback: function($$v) {
        _vm.search_item_bns = $$v
      },
      expression: "search_item_bns"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品属性"
    },
    model: {
      value: (_vm.params.items_attr),
      callback: function($$v) {
        _vm.$set(_vm.params, "items_attr", $$v)
      },
      expression: "params.items_attr"
    }
  }, _vm._l((_vm.itemsAttrArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "placeholder": "商品属性",
        "label": item,
        "value": index
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "商品属性范围"
    },
    model: {
      value: (_vm.params.items_scope),
      callback: function($$v) {
        _vm.$set(_vm.params, "items_scope", $$v)
      },
      expression: "params.items_scope"
    }
  }, _vm._l((_vm.itemsScopeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "placeholder": "商品属性范围",
        "label": item,
        "value": index
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 7
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "vip商品"
    },
    on: {
      "change": _vm.goodsSearch
    },
    model: {
      value: (_vm.params.vip_flag),
      callback: function($$v) {
        _vm.$set(_vm.params, "vip_flag", $$v)
      },
      expression: "params.vip_flag"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "vip商品",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "非vip商品",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 12
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.searchAction
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, _vm._l((_vm.tabList), function(item, index) {
    return _c('el-tab-pane', {
      key: index,
      attrs: {
        "label": item.name,
        "name": item.activeName
      }
    }, [(_vm.activeName == 'second') ? _c('div', {
      staticStyle: {
        "margin-bottom": "15px",
        "width": "280px"
      }
    }, [_c('el-input', {
      attrs: {
        "value": "warning_store"
      },
      model: {
        value: (_vm.warning_store),
        callback: function($$v) {
          _vm.warning_store = $$v
        },
        expression: "warning_store"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("预警数量")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "slot": "append"
      },
      on: {
        "click": _vm.setWarningStore
      },
      slot: "append"
    }, [_vm._v("保存")])], 2)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList,
        "height": _vm.wheight - 330
      },
      on: {
        "selection-change": _vm.handleSelectionChange
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "align": "center",
        "label": "全选"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "操作",
        "width": "100",
        "fixed": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-button', {
            staticClass: "btn-gap",
            attrs: {
              "type": "text"
            },
            on: {
              "click": function($event) {
                return _vm.editItemsAction(scope.$index, scope.row, false)
              }
            }
          }, [_vm._v("编辑\n              ")])]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "goods_id",
        "label": "商品ID",
        "width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              货号:" + _vm._s(scope.row.item_bn)), _c('br'), _vm._v("\n              默认ID:" + _vm._s(scope.row.goods_id)), _c('br'), _vm._v("\n              当前ID:" + _vm._s(scope.row.item_id) + "\n            ")]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "itemName",
        "label": "商品名称",
        "width": "180"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v("\n              " + _vm._s(scope.row.item_name) + "\n              "), (scope.row.special_type == 'drug') ? _c('el-tag', {
            attrs: {
              "type": "danger",
              "size": "mini"
            }
          }, [_vm._v("处方药")]) : _vm._e(), _vm._v(" "), (scope.row.is_settle_in == true) ? _c('el-tag', {
            attrs: {
              "type": "danger",
              "size": "mini"
            }
          }, [_vm._v("服务商品")]) : _vm._e()]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "图片"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-popover', {
            attrs: {
              "placement": "top",
              "width": "240",
              "trigger": "click"
            },
            model: {
              value: (_vm.visible),
              callback: function($$v) {
                _vm.visible = $$v
              },
              expression: "visible"
            }
          }, [_c('img', {
            staticStyle: {
              "width": "180%",
              "height": "180%"
            },
            attrs: {
              "src": _vm.newimageurl
            }
          }), _vm._v(" "), _c('el-button', {
            attrs: {
              "slot": "reference",
              "type": "text"
            },
            slot: "reference"
          }, [_c('ul', {
            staticClass: "goodspic-wrap"
          }, _vm._l((scope.row.pics), function(item, index) {
            return _c('li', {
              key: index,
              staticClass: "goodspic"
            }, [_c('img', {
              staticStyle: {
                "width": "95%",
                "height": "95%"
              },
              attrs: {
                "src": _vm.wximageurl + item
              },
              on: {
                "click": function($event) {
                  return _vm.showtitle(_vm.wximageurl + item)
                }
              }
            })])
          }), 0)])], 1)]
        }
      }], null, true)
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "content-center content-top-padded"
    }, [_c('el-pagination', {
      attrs: {
        "background": "",
        "layout": "total, sizes, prev, pager, next",
        "current-page": _vm.params.page,
        "page-sizes": [10, 20, 50, 100, 200],
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange,
        "size-change": _vm.handleSizeChange,
        "update:currentPage": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        },
        "update:current-page": function($event) {
          return _vm.$set(_vm.params, "page", $event)
        }
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改运费模板",
      "visible": _vm.addTemplatesdialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addTemplatesdialogVisible = $event
      }
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "运费模板"
    },
    model: {
      value: (_vm.templates_new_id),
      callback: function($$v) {
        _vm.templates_new_id = $$v
      },
      expression: "templates_new_id"
    }
  }, _vm._l((_vm.templatesList), function(item) {
    return _c('el-option', {
      key: item.template_id,
      attrs: {
        "label": item.name,
        "value": item.template_id
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addTemplatesdialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeTemplates
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "更改商品分类",
      "visible": _vm.addCategorydialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addCategorydialogVisible = $event
      }
    }
  }, [_c('treeselect', {
    attrs: {
      "options": _vm.categoryList,
      "multiple": true,
      "show-count": true,
      "disable-branch-nodes": true
    },
    model: {
      value: (_vm.category_id),
      callback: function($$v) {
        _vm.category_id = $$v
      },
      expression: "category_id"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.addCategorydialogVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeCategory
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "为商品打标签",
      "visible": _vm.tag.dialog,
      "before-close": _vm.handleCancelLabelsDialog
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.tag, "dialog", $event)
      }
    }
  }, [_c('div', {
    staticClass: "tag-users view-flex view-flex-middle"
  }, [_c('i', {
    staticClass: "iconfont icon-user-circle1"
  }), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.tag.editItem), function(item) {
    return _c('span', [_vm._v(" " + _vm._s(item) + "，")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "selected-tags view-flex"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("已选中标签：")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.tag.currentTags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": "",
        "size": "small",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.tagRemove(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])
  }), 1)]), _vm._v(" "), _c('div', _vm._l((_vm.tag.tags), function(tag, index) {
    return _c('el-tag', {
      key: index,
      staticClass: "tag-item",
      attrs: {
        "size": "medium",
        "color": "#ffffff",
        "disable-transitions": false
      },
      nativeOn: {
        "click": function($event) {
          return _vm.tagAdd(tag, index)
        }
      }
    }, [_vm._v("\n          " + _vm._s(tag.tag_name) + "\n        ")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.tag.dialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitItemTag
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    staticClass: "right-dialog",
    attrs: {
      "title": "商品下标签",
      "visible": _vm.tag.dialogdel,
      "before-close": _vm.handleCancelLabelsDialogdel
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.tag, "dialogdel", $event)
      }
    }
  }, [_c('div', {
    staticClass: "selected-tags view-flex"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("选择标签：")]), _vm._v(" "), _c('div', {
    staticClass: "view-flex-item"
  }, _vm._l((_vm.deltaglist), function(tag, index) {
    return _c('el-tag', {
      key: index,
      attrs: {
        "closable": "",
        "size": "small",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.tagdelone(index)
        }
      }
    }, [_vm._v("\n            " + _vm._s(tag.tag_name) + "\n          ")])
  }), 1)]), _vm._v(" "), _c('div'), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.tag.dialogdel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitItemTagdel
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_rebate_sideBar,
      "title": "商品分销配置",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_rebate_sideBar = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [(_vm.popularizeSetting.popularize_ratio.type == 'profit') ? _c('span', [_c('el-alert', {
      staticClass: "alert-text",
      attrs: {
        "title": "返佣计算类型: 【按利润分佣】",
        "description": "计算方式：商品利润 ×  百分比，其中商品利润为【支付金额-运费-商品成本价】，如果设置的返佣为固定金额，则不会按利润返佣，返佣金额就是设置的固定金额。如果不填则使用通用配置返佣",
        "type": "info",
        "close-text": " ",
        "show-icon": ""
      }
    })], 1) : _c('span', [_c('el-alert', {
      staticClass: "alert-text",
      attrs: {
        "title": "返佣计算类型: 【按订单金额分佣】",
        "description": "计算方式： 订单金额 × 百分比，其中订单金额为【支付金额-运费】，如果设置的返佣为固定金额，则不会按订单金额分佣，返佣金额就是设置的固定金额。如果不填则使用通用配置返佣",
        "type": "info",
        "close-text": " ",
        "show-icon": ""
      }
    })], 1)]), _vm._v("\n          商品名称：" + _vm._s(_vm.current.item_name) + "\n          "), _c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.skuLoading),
        expression: "skuLoading"
      }],
      attrs: {
        "data": _vm.rebateSpecItems
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "规格",
        "prop": "item_spec_desc",
        "min-width": "120"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(scope.row.item_spec_desc) ? _c('span', [_vm._v(_vm._s(scope.row.item_spec_desc))]) : _c('span', [_vm._v("单规格")])]
        }
      }], null, false, 215542460)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "商品价格",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.price / 100))]
        }
      }], null, false, 2635551072)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "成本价",
        "min-width": "80"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_vm._v(" ¥" + _vm._s(scope.row.cost_price / 100))]
        }
      }], null, false, 2644852212)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "类型",
        "width": "160"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-switch', {
            attrs: {
              "active-value": "money",
              "inactive-value": "ratio",
              "active-text": "金额",
              "inactive-text": "比例"
            },
            model: {
              value: (scope.row.rebate_conf.type),
              callback: function($$v) {
                _vm.$set(scope.row.rebate_conf, "type", $$v)
              },
              expression: "scope.row.rebate_conf.type"
            }
          })]
        }
      }], null, false, 2697424283)
    }), _vm._v(" "), _vm._l((_vm.popularizeSetting.popularize_ratio.profit), function(item, key) {
      return _c('el-table-column', {
        key: key,
        attrs: {
          "label": item.name,
          "min-width": "110"
        },
        scopedSlots: _vm._u([{
          key: "default",
          fn: function(scope) {
            return [(scope.row.rebate_conf.type == 'money') ? _c('el-input', {
              attrs: {
                "type": "number",
                "size": "mini",
                "suffix-icon": "iconfont icon-yen-sign"
              },
              model: {
                value: (scope.row.rebate_conf.value[key]),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.value, key, $$v)
                },
                expression: "scope.row.rebate_conf.value[key]"
              }
            }) : _c('el-input', {
              attrs: {
                "size": "mini",
                "type": "number",
                "suffix-icon": "iconfont icon-percent"
              },
              model: {
                value: (scope.row.rebate_conf.value[key]),
                callback: function($$v) {
                  _vm.$set(scope.row.rebate_conf.value, key, $$v)
                },
                expression: "scope.row.rebate_conf.value[key]"
              }
            })]
          }
        }], null, true)
      })
    })], 2)], 1)]
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveRebateConf
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_sideBar,
      "title": "设置价格",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_sideBar = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "编辑提示",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            如果填写店铺id则以店铺id为准\n          ")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属大区："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺id(多个店铺用英文逗号隔开)： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写店铺id"
    },
    model: {
      value: (_vm.districtId),
      callback: function($$v) {
        _vm.districtId = $$v
      },
      expression: "districtId"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.skuLoading),
      expression: "skuLoading"
    }],
    attrs: {
      "data": _vm.specItems,
      "height": "25%"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "规格",
      "prop": "item_spec_desc",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "商品价格",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.item_id !== _vm.currentId) ? _c('div', [_vm._v("\n              ¥" + _vm._s(scope.row.price) + "\n              "), _c('i', {
          staticClass: "el-input__icon el-icon-edit",
          on: {
            "click": function($event) {
              return _vm.editPrice(scope.row.item_id, scope.row.price)
            }
          }
        })]) : _c('el-input', {
          ref: 'input_' + scope.row.item_id,
          attrs: {
            "size": "mini"
          },
          on: {
            "blur": function($event) {
              return _vm.handleBlur(scope.$index, scope)
            }
          },
          model: {
            value: (_vm.currentPrice),
            callback: function($$v) {
              _vm.currentPrice = $$v
            },
            expression: "currentPrice"
          }
        })]
      }
    }], null, false, 251589538)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "修改后价格"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          ref: 'input_' + scope.row.item_id,
          attrs: {
            "size": "mini"
          },
          model: {
            value: (_vm.currentPriceChange),
            callback: function($$v) {
              _vm.currentPriceChange = $$v
            },
            expression: "currentPriceChange"
          }
        })]
      }
    }], null, false, 4116491537)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "价格同步至指定门店"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "loading": _vm.batchsubmitLoading
          },
          on: {
            "click": function($event) {
              return _vm.syncPrice(scope.row.item_id)
            }
          }
        }, [_vm._v("同步商品价格\n            ")])]
      }
    }], null, false, 3282361194)
  })], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.skuLoading),
      expression: "skuLoading"
    }],
    attrs: {
      "data": _vm.specItems
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "以下店铺价格和商品价格不同"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-collapse', [_c('el-collapse-item', {
          attrs: {
            "title": "",
            "name": "1"
          }
        }, _vm._l((scope.row.distributors_prices_arr), function(distritors_prics, key, value) {
          return _c('div', [_vm._v("\n                      店铺id " + _vm._s(key.split('_')[1]) + " 价格:￥" + _vm._s(distritors_prics / 100) + "\n                    ")])
        }), 0)], 1)]
      }
    }], null, false, 466143848)
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_itemStore,
      "title": "设置商品库存",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_itemStore = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.skuLoading),
        expression: "skuLoading"
      }],
      attrs: {
        "data": _vm.storeItemsList,
        "height": "100%"
      }
    }, [_c('el-table-column', {
      attrs: {
        "label": "规格",
        "prop": "item_spec_desc",
        "min-width": "120"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "库存"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "size": "mini",
              "type": "number"
            },
            model: {
              value: (scope.row.store),
              callback: function($$v) {
                _vm.$set(scope.row, "store", $$v)
              },
              expression: "scope.row.store"
            }
          })]
        }
      }], null, false, 3907094231)
    })], 1)]
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveItemsStore
    }
  }, [_vm._v("保存")])], 1)], 2), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_batchStore,
      "title": "商品批量同步到店铺",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_batchStore = $event
      }
    }
  }, [_c('div', {
    staticClass: "content-bottom-padded"
  }, [_c('el-alert', {
    attrs: {
      "type": "info",
      "title": "编辑提示",
      "show-icon": ""
    }
  }, [_c('div', [_vm._v("\n            如果输入店铺id(英克id)则店铺类型和区域类型无效。"), _c('br'), _vm._v("\n            店铺类型和店铺区域不能同时选择"), _c('br'), _vm._v("\n            店铺区域属于怡康自营门店和第三方门店无关\n          ")])])], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品id："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.current) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品价格："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              ¥" + _vm._s(_vm.current_goods_price) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺类型： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "选择店铺类型"
    },
    model: {
      value: (_vm.params.shop_type_id),
      callback: function($$v) {
        _vm.$set(_vm.params, "shop_type_id", $$v)
      },
      expression: "params.shop_type_id"
    }
  }, [_vm._l((_vm.shop_type_list_default), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.shop_type_list), function(shop) {
    return _c('el-option', {
      key: shop.shop_type_id,
      attrs: {
        "label": shop.shop_type_name,
        "value": shop.shop_type_id
      }
    })
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "区域分类"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-cascader', {
    attrs: {
      "placeholder": "所属大区",
      "options": _vm.new_office_area,
      "props": {
        checkStrictly: true
      },
      "clearable": ""
    },
    on: {
      "change": _vm.handleOfficeChange
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.show_item_stock) ? _c('el-form-item', {
    attrs: {
      "label": "库存： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "maxlength": 30,
      "placeholder": "请填写库存"
    },
    model: {
      value: (_vm.stock),
      callback: function($$v) {
        _vm.stock = $$v
      },
      expression: "stock"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-edit",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "上下架操作： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.is_open),
      callback: function($$v) {
        _vm.is_open = $$v
      },
      expression: "is_open"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺英克ID(多个ID用英文逗号隔开)： "
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请填写店铺id"
    },
    model: {
      value: (_vm.districtId),
      callback: function($$v) {
        _vm.districtId = $$v
      },
      expression: "districtId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 50%"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveSynsc
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_batch_vipdiscount,
      "title": "批量设置尊享会员折扣",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_batch_vipdiscount = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品货号："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v("\n              " + _vm._s(this.item_bn) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品折扣："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "precision": 0,
      "placeholder": "商品折扣"
    },
    model: {
      value: (_vm.current_item_vip_discount),
      callback: function($$v) {
        _vm.current_item_vip_discount = $$v
      },
      expression: "current_item_vip_discount"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-edit",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("折扣取值范围在 0 - 100 之间，按百分比计算。（如：输入 88 就等价于 8.8 折）")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注意："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "16px"
    }
  }, [_vm._v("当前共对 " + _vm._s(this.item_bn.length) + " 个商品进行会员折扣设置，请仔细核对后再点击保存！修改成功后请仔细核查前后端页面所展示的会员价格！！！")])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 50%"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "element-loading-text": "提交中，请稍后",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.batchSaveVipDiscount
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.show_vipdiscount,
      "title": "设置尊享会员折扣",
      "width": "60"
    },
    on: {
      "update:visible": function($event) {
        _vm.show_vipdiscount = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "left"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品ID："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.current_item_id) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品货号："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              " + _vm._s(_vm.current_item_bn) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品价格："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              ¥" + _vm._s(_vm.current_goods_price) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品折扣："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0,
      "max": 100,
      "step": 1,
      "precision": 0,
      "placeholder": "商品折扣"
    },
    model: {
      value: (_vm.current_item_vip_discount),
      callback: function($$v) {
        _vm.current_item_vip_discount = $$v
      },
      expression: "current_item_vip_discount"
    }
  }, [_c('i', {
    staticClass: "el-input__icon el-icon-edit",
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("折扣取值范围在 0 - 100 之间，按百分比计算。（如：输入 88 就等价于 8.8 折）")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "会员折后价格："
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n              ¥" + _vm._s(_vm.current_goods_price * _vm.current_item_vip_discount / 100) + "\n            ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 50%"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.saveVipDiscount
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量修改库存",
      "visible": _vm.storeUpdate,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.storeUpdate = $event
      }
    }
  }, [_vm._v("\n      统一库存：\n      "), _c('el-input', {
    attrs: {
      "size": "mini",
      "type": "number"
    },
    model: {
      value: (_vm.itemstore),
      callback: function($$v) {
        _vm.itemstore = $$v
      },
      expression: "itemstore"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.storeUpdate = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveItemsStore
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "批量修改价格",
      "visible": _vm.batchGoodsPricesView,
      "width": "60%"
    },
    on: {
      "update:visible": function($event) {
        _vm.batchGoodsPricesView = $event
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n          正在编辑" + _vm._s(_vm.goodsNum) + "条数据。\n        ")])], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_vm._v("\n          小技巧:\n          "), _c('span', {
    staticClass: "price-content"
  }, [_vm._v("\n                  直接修改：对所选商品的某个价格进行统一修改。")]), _vm._v(" "), _c('span', {
    staticClass: "price-content"
  }, [_vm._v("\n                  公式调价：将所选商品的某个价格修改为在另一个价格的基础上加减乘一个数字。")]), _vm._v(" "), _c('span', {
    staticClass: "price-content-ts"
  }, [_vm._v("\n                  提示：公式调价中，等号两边列表中的会员价表示的意义不同，")]), _vm._v(" "), _c('span', {
    staticClass: "price-content"
  }, [_vm._v("\n                  等号前边是最终的结果(公式计算的最终结果，直接保存为会员价格)，")]), _vm._v(" "), _c('span', {
    staticClass: "price-content"
  }, [_vm._v("\n                  等号后边是计算公式中的参数（他的值为原销售价*会员等级的折扣率）。\n                ")])])], 1), _vm._v(" "), _c('el-radio-group', {
    on: {
      "change": _vm.changeHandler
    },
    model: {
      value: (_vm.price_mode),
      callback: function($$v) {
        _vm.price_mode = $$v
      },
      expression: "price_mode"
    }
  }, [_c('el-row', {
    staticClass: "batch_price",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 40
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "direct"
    }
  }, [_vm._v("直接修改")]), _vm._v(" "), _c('el-select', {
    staticClass: "pri-sel",
    attrs: {
      "clearable": "",
      "placeholder": "价格类型"
    },
    on: {
      "change": _vm.price_type_direct_act
    },
    model: {
      value: (_vm.price_type_direct_sel),
      callback: function($$v) {
        _vm.price_type_direct_sel = $$v
      },
      expression: "price_type_direct_sel"
    }
  }, _vm._l((_vm.price_type_direct), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "价格类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-tag', {
    staticClass: "pri-tag"
  }, [_vm._v("=")]), _vm._v(" "), _c('el-input', {
    staticClass: "pri-inp",
    attrs: {
      "placeholder": "价格(分)",
      "size": "mini",
      "type": "text"
    },
    model: {
      value: (_vm.newPrice),
      callback: function($$v) {
        _vm.newPrice = $$v
      },
      expression: "newPrice"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "batch_price",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 60
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "formula"
    }
  }, [_vm._v("公式修改")]), _vm._v(" "), _c('el-select', {
    staticClass: "pri-sel",
    attrs: {
      "clearable": "",
      "placeholder": "价格类型"
    },
    on: {
      "change": _vm.price_type_formula_act
    },
    model: {
      value: (_vm.price_type_formula_sel),
      callback: function($$v) {
        _vm.price_type_formula_sel = $$v
      },
      expression: "price_type_formula_sel"
    }
  }, _vm._l((_vm.price_type_formula), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "价格类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-tag', {
    staticClass: "pri-tag"
  }, [_vm._v("=")]), _vm._v(" "), _c('el-select', {
    staticClass: "pri-sel",
    attrs: {
      "clearable": "",
      "placeholder": "价格类型"
    },
    on: {
      "change": _vm.price_type_main_act
    },
    model: {
      value: (_vm.price_type_main_sel),
      callback: function($$v) {
        _vm.price_type_main_sel = $$v
      },
      expression: "price_type_main_sel"
    }
  }, _vm._l((_vm.price_type_main), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "价格类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-select', {
    staticClass: "pri-sel",
    attrs: {
      "clearable": "",
      "placeholder": "价格类型"
    },
    on: {
      "change": _vm.algorithmVal_act
    },
    model: {
      value: (_vm.algorithmVal),
      callback: function($$v) {
        _vm.algorithmVal = $$v
      },
      expression: "algorithmVal"
    }
  }, _vm._l((_vm.algorithm), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "placeholder": "价格类型",
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('el-input', {
    staticClass: "pri-inp",
    attrs: {
      "placeholder": "加减时（分）",
      "size": "mini",
      "type": "text"
    },
    model: {
      value: (_vm.newPrice2),
      callback: function($$v) {
        _vm.newPrice2 = $$v
      },
      expression: "newPrice2"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.batchGoodsPricesView = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.savebatchGoodsPrices
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-25da0412", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25da0412"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/goods/physical/imagelist.vue
// module id = 2547
// module chunks = 0